import { render, staticRenderFns } from "./tipicBody.vue?vue&type=template&id=0cbd1cb4&scoped=true&"
import script from "./tipicBody.vue?vue&type=script&lang=js&"
export * from "./tipicBody.vue?vue&type=script&lang=js&"
import style0 from "./tipicBody.vue?vue&type=style&index=0&id=0cbd1cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd1cb4",
  null
  
)

export default component.exports